<template>
    <div class="questionnaire-select">
        <div class="questionnaire-title">{{content}}</div>

        <div class="questionnaire-nationality-content" @click="handleClick">
            <div :class="`questionnaire-nationality-text ${text ? 'questionnaire-nationality-text-value' : ''}`">{{text ? text : '请选择...'}}</div>
            <img :class="`questionnaire-nationality-icon ${isShow ? 'questionnaire-nationality-icon-active' : ''}`" :src="pullPng" alt="">
        </div>
        <van-popup v-model="isShow" position="bottom">
            <van-picker show-toolbar value-key="content" :default-index="defaultIndex" :columns="options" @confirm="handleConfirm" @cancel="handleCancel" />
        </van-popup>
    </div>
</template>

<script>
import pullPng from '@/assets/reserve/questionnaire/pull.png'
export default {
    data() {
        return {
			pullPng: pullPng,
			isShow: false,
			text: "",
			defaultIndex: ""
        }
    },
    props: {
        value: {
            type: Array,
			default: () => {
				return []
			}
        },
        content: {
            type: String,
            default: ""
        },
        options: {
            type: Array,
            default: () => {
                return []
            }
        },
        disabled: {
            type: Boolean,
            default: false
        },
        score: {
			type: String,
			default: ""
		}
	},
	model: {
		prop: 'value',
		event: 'change'
	},
	mounted() {
		if (this.value[0] && Array.isArray(this.options)) {
			for (let i = 0; i < this.options.length; i++) {
				if (this.options[i].code === this.value[0]) {
					this.text = this.options[i].content
					this.defaultIndex = i
				}
			}
		}

	},
    methods: {
        /**
            处理点击content事件
            @param 
            @return
        */
        handleClick() {
            if (!this.disabled) {
				this.isShow = true
			}
		},

		/**
            处理popup点击确定事件
            @param 
            @return
        */
		handleConfirm(event) {
			this.text = event.content
			this.$emit('change', [event.code])
			this.isShow = false
		},

		/**
            处理popup点击取消事件
            @param 
            @return
        */
		handleCancel() {
			this.isShow = false
		}
    }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/reserve/questionnaire/components/select.vue